import { render, staticRenderFns } from "./WidgetInstaller.vue?vue&type=template&id=271af1b4"
import script from "./WidgetInstaller.vue?vue&type=script&lang=js"
export * from "./WidgetInstaller.vue?vue&type=script&lang=js"
import style0 from "./WidgetInstaller.vue?vue&type=style&index=0&id=271af1b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports